<template>
  <v-dialog
    v-model="isOpen"
		fullscreen
    scrollable
  >
    <v-card v-if="item" class="fm-document-viewer pa-0">
      <div class="d-flex align-center justify-space-between fm-document-header">
				<img :src="require('@/assets/Svg/logoWhite.svg')" style="max-width: 110px; width: 100%;"/>
				<div class="d-flex align-center">
					<v-icon class="mr-3" color="white" v-if="!isMobile">{{ getFileIcon }}</v-icon>
					<div class="font-weight-medium text-truncate" v-if="!isMobile">{{ item.name }}</div>
				</div>
				<div class="d-flex align-center" style="gap: 8px;">
					<v-chip small outlined color="white" label v-if="!isMobile">{{ getFileInfo }}</v-chip>
					<v-tooltip top>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								icon
								small
								@click="associationsOpen = !associationsOpen"
								color="white"
								v-bind="attrs"
								v-on="on"
							>
								<v-icon>mdi-link-variant</v-icon>
							</v-btn>
						</template>
						<span>Asociaciones</span>
					</v-tooltip>
          <RevisionFileSelector
            :revision-context="revisionContext"
            :current-file-id="item.id"
            :loading="revisionLoading"
            @select="$emit('select-revision', $event)"
          />
					<v-btn icon small @click="openInNewTab" class="ml-1" color="white">
						<v-icon>mdi-open-in-new</v-icon>
					</v-btn>
					<div>
						<v-tooltip top>
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									icon
									small
									:href="item.url"
									target="_blank"
									color="white"
									v-bind="attrs"
									v-on="on"
								>
									<v-icon>mdi-download</v-icon>
								</v-btn>
							</template>
							<span>Descargar archivo</span>
						</v-tooltip>
					</div>
					<v-btn icon small @click="$emit('minimize-file', item)" class="ml-1" color="white">
						<v-icon>mdi-minus</v-icon>
					</v-btn>
					<v-btn icon small @click="closeDialog" class="ml-1" color="white">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</div>
      </div>
      <v-card-text class="fm-document-content pa-0">
				<ForgeViewer :item="item" />
      </v-card-text>
			<AssociationsListModal v-model="associationsOpen" :file-id="item.id" />
    </v-card>
  </v-dialog>
</template>

<script>
import ForgeViewer from '@/components/Views/Planimetria/ForgeViewer'
import AssociationsListModal from '@/components/Globals/Helpers/AssociationsListModal'
import RevisionFileSelector from '@/components/Globals/Helpers/RevisionFileSelector'

export default {
  name: 'ForgeFileViewer',
  components: { ForgeViewer, AssociationsListModal, RevisionFileSelector },
  props: {
    item: {
      type: Object,
      default: null
    },
    revisionContext: {
      type: Object,
      default: null
    },
    revisionLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loadFailed: false,
      isOpen: false,
			loading: true,
			associationsOpen: false
    }
  },
  watch: {
    item(newVal) {
      if (newVal) {
        this.isOpen = true
				this.$store.forgeStore.commit('setForgeSelectedFile', this.item)
      }
    }
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mobile
    },
    getFileIcon() {
      return 'mdi-file-cad'
    },
    getFileInfo() {
      const ext = this.item?.ext?.toUpperCase() || 'ARCHIVO'
      const size = this.getFileSize()
      return `${ext}${size ? ` • ${size}` : ''}`
    }
  },
	mounted() {
		if (this.item) {
			this.isOpen = true
			this.$store.forgeStore.commit('setForgeSelectedFile', this.item)
		}
	},
  methods: {
		openInNewTab() {
			if (this.item) {
				const width = window.outerWidth;
				const height = window.outerHeight;
				const left = window.screenX;
				const top = window.screenY;
				const url = 'forge-viewer?item_id=' + this.item.id;
				window.open(
					url,
					'_blank',
					`width=${width},height=${height},left=${left},top=${top},noopener,noreferrer`
				);
				this.closeDialog();
			}
		},
    onIframeError() {
      this.loadFailed = true
    },

    onIframeLoad() {
      this.loadFailed = false
    },

    closeDialog() {
      this.isOpen = false
			this.associationsOpen = false
			this.$emit('close')
			window.close()
    },
    getFileSize() {
      const size = this.item?.size
      if (!size) return null
      if (size < 1024) return `${size} B`
      if (size < 1024 * 1024) return `${(size / 1024).toFixed(2)} KB`
      return `${(size / (1024 * 1024)).toFixed(2)} MB`
    }
  }
}
</script>

<style scoped>
.fm-document-viewer {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.fm-document-header {
  border-bottom: 1px solid #213872;
  padding: 8px 16px !important;
  background: #2D4B95;
	color: white;
}

.fm-document-header .v-toolbar__content {
  padding: 0 !important;
}

.fm-document-content {
  flex: 1;
  overflow-y: auto;
  background: #fafafa;
}

.document-viewer-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.document-viewer-iframe {
  width: 100%;
  height: 100%;
  background: white;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
  border-radius: 6px;
  border: none;
}
</style>